import { useState, useEffect, useRef } from 'react';
import { shuffleArray } from '@/common/utils/shuffleArray';
import {
  PROMPT_SUGGESTIONS,
  PROMPT_ROTATE_MS,
  PROMPT_FADE_MS,
} from './workspaceSetup.constants';

/**
 * Prompt carousel — runs independently so users still see prompts cycling
 * even when the backend is slow and step 3 is still pending.
 */
export function usePromptCarousel() {
  const [currentPrompt, setCurrentPrompt] = useState(0);
  const [fadeClass, setFadeClass] = useState('fade-in');
  const promptsRef = useRef(shuffleArray(PROMPT_SUGGESTIONS));

  useEffect(() => {
    const interval = setInterval(() => {
      setFadeClass('fade-out');
      setTimeout(() => {
        setCurrentPrompt((i) => (i + 1) % promptsRef.current.length);
        setFadeClass('fade-in');
      }, PROMPT_FADE_MS);
    }, PROMPT_ROTATE_MS);

    return () => clearInterval(interval);
  }, []);

  return { currentPrompt, fadeClass, prompts: promptsRef.current };
}
